module.exports = __webpack_public_path__ + "img/awto-header@3x.51f1074f.png";